import { useContext } from "react";
import { AuthAsContext } from "../../contexts/AuthAs";

export default function useAuthAs() {
  const value = useContext(AuthAsContext);
  return value;
}
